import FormAsyncTC from "../FormAsyncTC";
import React from "react";

export function FormAsyncPreDiningArrangement({ name = "pre_dining_arrangement_id" }: { name?: string }) {
  return (
    <FormAsyncTC
      async={{
        url: "core/arrangements/search?fields=id as value, name as label&per_page=50",
        searchField: "arrangements",
        extraFilters: { field: "variant", value: "pre-dining", operator: "=" },
      }}
      name={name}
      tDefault={"Pre dining arrangement"}
      tKey={"Pre dining arrangement"}
    />
  );
}
